module.exports = __webpack_public_path__ + "static/img/pic-01.f531c05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/pic-01.png
// module id = 5+GW
// module chunks = 1